<template>
  <transition-group name="list-fade" tag="div" class="c-toasts c-toasts--top-right">
    <toast class="list-fade-item" v-for="toast in toasts" :toast="toast" :key="toast.id"></toast>
  </transition-group>
</template>

<script>
  // Vuex
  import { mapGetters, mapActions } from 'vuex';

  // Components
  import toast from './Toast.vue';

  export default {
    components: {
      toast
    },

    computed: {
      ...mapGetters([
        'toasts'
      ])
    }
  };
</script>


// WEBPACK FOOTER //
// ../../../../resources/assets/js/shared/components/Toasts.vue